import ApiAttachment from '@/model/Attachment';
import * as pbm from '@/grpc-gen/reservation_pb';

export default class Attachment extends ApiAttachment {
  static fromGrpcModel(o?: pbm.ReservationAttachment): Attachment {
    const e = new Attachment();

    e.name = o?.name ?? '';
    e.url = o?.url ?? '';

    return e;
  }
}
